import * as SwitchPrimitives from '@radix-ui/react-switch'
import * as React from 'react'
import { cname } from '../utils'

/**
 * Switch 组件封装（Radix Switch）
 *
 * - 支持可选的左右文案 `texts=[onText, offText]`
 * - 使用 data-state 控制滑块与文案显隐/位移
 */
// 'group peer relative inline-flex h-5 min-w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input',
const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, texts = null, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cname(
      'switchUniBack group peer relative inline-flex h-5 min-w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=unchecked]:bg-input',
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cname(
        'pointer-events-none block h-3.5 w-3.5 min-w-3.5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:ml-[100%] data-[state=checked]:translate-x-[calc(-50%-8px)] data-[state=unchecked]:translate-x-0'
      )}
    />
    {texts && (
      <>
        <span className="text absolute left-1 hidden text-xs text-gray-50 group-data-[state=checked]:block">
          {texts[0]}
        </span>
        <span className="text absolute right-1 hidden text-xs text-gray-400 group-data-[state=unchecked]:block">
          {texts[1]}
        </span>
      </>
    )}
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
